import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as JoyBuddy } from '../../../../../assets/icons/buddy-joy.svg';
import { BreadcrumbItemProps } from '../../../../../shared/components/Breadcrumbs/BreadcrumbItem/BreadcrumbItem';
import GenericPageNE from '../../../../../shared/components/GenericPageNE/GenericPageNE';
import { REWARDS_HISTORY_ROUTE } from '../../../../../shared/constants/auth';
import { CLICK_ACTION, GO_TO_ORDER_HISTORY } from '../../../../../shared/constants/tagManager';
import tagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_LOAD_BALANCE } from '../../../../../shared/translations/rewards';
import { GenericVoidFunction } from '../../../../../shared/types/genericTypes';
import { RewardsBalancePaymentMethods } from '../../../../../shared/types/rewards';

interface LoadBalanceSuccessProps {
  breadcrumbs: BreadcrumbItemProps[];
  loadMoreBalance: GenericVoidFunction;
  orderLabel: string;
  paymentMethod: number;
}

const LoadBalanceSuccess = ({ breadcrumbs, loadMoreBalance, orderLabel, paymentMethod }: LoadBalanceSuccessProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const goToHistory = () => {
    tagManagerService.pushEvent(CLICK_ACTION, GO_TO_ORDER_HISTORY);
    navigate(REWARDS_HISTORY_ROUTE);
  };

  const getDescription = (): string | null => {
    if (paymentMethod === RewardsBalancePaymentMethods['bank-transfer']) {
      return t(TRANSLATION_LOAD_BALANCE.success.transferDescription);
    }
    if (paymentMethod === RewardsBalancePaymentMethods['credit-line']) {
      return t(TRANSLATION_LOAD_BALANCE.success.creditDescription);
    }
    return null;
  };

  return (
    <GenericPageNE
      breadcrumbs={breadcrumbs}
      ImageComponent={JoyBuddy}
      title={{
        i18nKey: TRANSLATION_LOAD_BALANCE.success.title,
        components: { 1: <br /> },
        values: { order: orderLabel }
      }}
      description={getDescription() ?? ''}
      primaryButton={{
        text: t(TRANSLATION_LOAD_BALANCE.success.primaryButton),
        action: goToHistory
      }}
      secondaryButton={{
        text: t(TRANSLATION_LOAD_BALANCE.success.secondaryButton),
        action: loadMoreBalance
      }}
    />
  );
};

export default LoadBalanceSuccess;
